const METAL = {
  label: 'Metal Mining, Gold and Silver Ores, Other mining',
  value: 'METAL',
  highRisk: false
};
const OIL_GAS = {
  label: 'Oil & Gas Field Exploration Services, Drilling Oil & Gas Wells, Other Oil and Gas',
  value: 'OIL_GAS',
  highRisk: true
};
const AUTO = {
  label: 'Wholesale – Auto',
  value: 'AUTO',
  highRisk: true
};
const DURABLE_GOODS = {
  label: 'Wholesale – Durable Goods',
  value: 'DURABLE_GOODS',
  highRisk: false
};
const LEISURE_PRODUCTS = {
  label: 'Wholesale – Leisure Products',
  value: 'LEISURE_PRODUCTS',
  highRisk: true
};
const MEDICAL = {
  label: 'Wholesale – Medical',
  value: 'MEDICAL',
  highRisk: false
};
const CONSUMER_GOODS = {
  label: 'Wholesale – Consumer goods',
  value: 'CONSUMER_GOODS',
  highRisk: false
};
const OTHER = {
  label: 'Wholesale – Other',
  value: 'OTHER',
  highRisk: false
};
const HOTELS = {
  label: 'Hotels',
  value: 'HOTELS',
  highRisk: true
};
const MARKETING = {
  label: 'Marketing Services, Computer Services',
  value: 'MARKETING',
  highRisk: false
};
const CASINO_GAMBLING = {
  label: 'Casino/Gambling, Auto Rental',
  value: 'CASINO_GAMBLING',
  highRisk: true
};
const MEDICAL_LEGAL = {
  label: 'Medical, Legal, Other Services',
  value: 'MEDICAL_LEGAL',
  highRisk: false
};
const TRAVEL_ENTERTAINMENT = {
  label: 'Travel, Entertainment, Oil and Gas, Airline, Hotel, Retail Sales, Automotive, Leisure Products',
  value: 'TRAVEL_ENTERTAINMENT',
  highRisk: true
};

// WARNING: potential naming clash with 'Wholesale – Other' above
const OTHERS = {
  label: 'Other',
  value: 'OTHER',
  highRisk: false
};
export const INDUSTRY_SUB_TYPES_MAP = {
  METAL,
  OIL_GAS,
  AUTO,
  DURABLE_GOODS,
  LEISURE_PRODUCTS,
  MEDICAL,
  CONSUMER_GOODS,
  OTHER,
  HOTELS,
  MARKETING,
  CASINO_GAMBLING,
  MEDICAL_LEGAL,
  TRAVEL_ENTERTAINMENT,
  OTHERS
};
export default {
  MINING: [METAL, OIL_GAS],
  WHOLESALE: [AUTO, DURABLE_GOODS, LEISURE_PRODUCTS, MEDICAL, CONSUMER_GOODS, OTHER],
  SERVICES: [HOTELS, MARKETING, CASINO_GAMBLING, MEDICAL_LEGAL],
  OTHER: [TRAVEL_ENTERTAINMENT, OTHERS]
};